import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "title-holder" }
const _hoisted_3 = {
  key: 0,
  fill: "none",
  height: "20",
  viewBox: "0 0 21 20",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = { class: "appointment-type" }
const _hoisted_5 = {
  key: 0,
  class: "mechanic-name"
}
const _hoisted_6 = { class: "content-container order-content" }
const _hoisted_7 = { class: "information" }
const _hoisted_8 = { class: "customer-email" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "information" }
const _hoisted_11 = { class: "key" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "grid collapse-columns" }
const _hoisted_14 = { class: "information" }
const _hoisted_15 = { class: "key" }
const _hoisted_16 = {
  key: 0,
  class: "value"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "cta-text" }
const _hoisted_19 = { class: "amount" }
const _hoisted_20 = { class: "information" }
const _hoisted_21 = { class: "key" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "grid collapse-columns" }
const _hoisted_24 = { class: "information" }
const _hoisted_25 = { class: "key" }
const _hoisted_26 = {
  key: 0,
  class: "value"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "cta-text" }
const _hoisted_29 = { class: "amount" }
const _hoisted_30 = { class: "current-situation" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "date"
}
const _hoisted_33 = {
  key: 0,
  class: "image-holder"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "edit-email-holder" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "swiper-zoom-container" }
const _hoisted_38 = ["src", "onError", "onLoad"]
const _hoisted_39 = { class: "category-holder" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "modal-content add-product-modal" }
const _hoisted_42 = {
  key: 1,
  class: "no-products-to-show"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["alt", "src"]
const _hoisted_45 = { class: "product-information" }
const _hoisted_46 = { class: "sku" }
const _hoisted_47 = { class: "product-name" }
const _hoisted_48 = { class: "price-check" }
const _hoisted_49 = { class: "price" }
const _hoisted_50 = {
  key: 0,
  slot: "end",
  class: "check",
  fill: "fill",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "modal-content" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "history-information" }
const _hoisted_55 = { class: "type" }
const _hoisted_56 = { class: "date" }
const _hoisted_57 = {
  key: 0,
  class: "has-comment"
}
const _hoisted_58 = {
  class: "defective-parts-choice",
  role: "group"
}
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "information" }
const _hoisted_62 = { class: "deal-owner" }
const _hoisted_63 = { class: "textarea-container" }
const _hoisted_64 = {
  key: 1,
  class: "mechanic_comment"
}
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { key: 0 }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_base_panel = _resolveComponent("base-panel")!
  const _component_product_list_item = _resolveComponent("product-list-item")!
  const _component_image_loader_overlay = _resolveComponent("image-loader-overlay")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_in_app_camera_modal = _resolveComponent("in-app-camera-modal")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_base_loader = _resolveComponent("base-loader")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_sheet_modal = _resolveComponent("sheet-modal")!
  const _component_ion_slide = _resolveComponent("ion-slide")!
  const _component_ion_slides = _resolveComponent("ion-slides")!
  const _component_card_modal = _resolveComponent("card-modal")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_defective_parts_section = _resolveComponent("defective-parts-section")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "page-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: "ionic-header ion-no-border",
        mode: "ios",
        "no-border": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            class: "toolbar",
            mode: "ios",
            "no-padding": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    icon: _ctx.BackIcon,
                    "default-href": "/",
                    text: "",
                    onClick: _ctx.handleBackClick
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "none",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
                          fill: "black"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["icon", "onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "title order-detail-title" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      (_ctx.order.is_finished)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("rect", {
                              fill: "#D98240",
                              height: "20",
                              rx: "10",
                              width: "20",
                              x: "0.5"
                            }, null, -1),
                            _createElementVNode("path", {
                              "clip-rule": "evenodd",
                              d: "M15.3816 7.34927C15.4957 7.46091 15.5528 7.59648 15.5528 7.75597C15.5528 7.91546 15.4957 8.05102 15.3816 8.16267L10.1253 13.3062C10.0112 13.4179 9.87265 13.4737 9.70966 13.4737C9.54667 13.4737 9.40813 13.4179 9.29404 13.3062L6.25024 10.3277C6.13615 10.2161 6.0791 10.0805 6.0791 9.92104C6.0791 9.76155 6.13615 9.62598 6.25024 9.51434L7.08148 8.70094C7.19557 8.5893 7.33411 8.53348 7.4971 8.53348C7.66009 8.53348 7.79863 8.5893 7.91272 8.70094L9.70966 10.4653L13.7192 6.53587C13.8333 6.42423 13.9718 6.36841 14.1348 6.36841C14.2978 6.36841 14.4363 6.42423 14.5504 6.53587L15.3816 7.34927Z",
                              fill: "white",
                              "fill-rule": "evenodd"
                            }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.order.appointment_type), 1)
                    ]),
                    (_ctx.user.isPlanner && _ctx.order.mechanic_name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Door " + _toDisplayString(_ctx.order.mechanic_name), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([{
							disabled: !(_ctx.order.appointment_history.length >= 1),
						}, "show-history"]),
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleHistoryModal && _ctx.toggleHistoryModal(...args)))
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("svg", {
                      fill: "none",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z",
                        fill: "black"
                      })
                    ], -1)
                  ]))], 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-content-container"
      }, {
        default: _withCtx(() => [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _createElementVNode("main", _hoisted_6, [
                _createVNode(_component_base_panel, null, {
                  content: _withCtx(() => [
                    _cache[23] || (_cache[23] = _createElementVNode("h3", null, "Klant", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.order.customer.name), 1),
                      _createElementVNode("p", null, _toDisplayString(new Date(_ctx.order.date).toLocaleDateString(
											"nl-NL",
											_ctx.dateOptions
										)) + " · " + _toDisplayString(_ctx.order.timeslot), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.order.customer.streetname) + " " + _toDisplayString([
											_ctx.order.customer.house_number,
											_ctx.order.customer
												.house_number_addition,
										]
											.filter((v) => v !== null)
											.join("-")) + ", " + _toDisplayString(_ctx.order.customer.city), 1),
                      _createElementVNode("p", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_ctx.order.customer.email) + " ", 1),
                        (
											!_ctx.order.is_finished &&
											(!_ctx.authenticatedUserIsPlanner ||
												_ctx.userId === _ctx.order.mechanic_id)
										)
                          ? (_openBlock(), _createElementBlock("svg", {
                              key: 0,
                              class: "edit",
                              fill: "none",
                              viewBox: "0 0 16 16",
                              xmlns: "http://www.w3.org/2000/svg",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openEditEmailModal && _ctx.openEditEmailModal(...args)))
                            }, [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("g", { opacity: "0.3" }, [
                                _createElementVNode("path", {
                                  d: "M2 11.5002V14.0002H4.5L11.8733 6.62687L9.37333 4.12687L2 11.5002ZM13.8067 4.69354C14.0667 4.43354 14.0667 4.01354 13.8067 3.75354L12.2467 2.19354C11.9867 1.93354 11.5667 1.93354 11.3067 2.19354L10.0867 3.41354L12.5867 5.91354L13.8067 4.69354V4.69354Z",
                                  fill: "black"
                                })
                              ], -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  cta: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "cta",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToLocation()))
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "fill",
                        viewBox: "0 0 25 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M22.21 11.2901L13.21 2.29006C12.82 1.90006 12.19 1.90006 11.8 2.29006L2.80001 11.2901C2.41001 11.6801 2.41001 12.3101 2.80001 12.7001L11.8 21.7001C12.19 22.0901 12.82 22.0901 13.21 21.7001L22.21 12.7001C22.6 12.3201 22.6 11.6901 22.21 11.2901ZM14.5 14.5001V12.0001H10.5V15.0001H8.50001V11.0001C8.50001 10.4501 8.95001 10.0001 9.50001 10.0001H14.5V7.50006L18 11.0001L14.5 14.5001Z",
                          fill: "fill"
                        })
                      ], -1),
                      _createElementVNode("span", { class: "cta-text" }, " Navigeren ", -1)
                    ]))]),
                    (_ctx.dialablePhone(_ctx.order.customer.phone))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `tel:${_ctx.dialablePhone(_ctx.order.customer.phone)}`,
                          class: "cta"
                        }, [...(_cache[25] || (_cache[25] = [
                          _createElementVNode("svg", {
                            class: "icon",
                            fill: "none",
                            viewBox: "0 0 25 24",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M20.51 15.38C19.28 15.38 18.09 15.18 16.98 14.82C16.63 14.7 16.24 14.79 15.97 15.06L14.4 17.03C11.57 15.68 8.92 13.13 7.51 10.2L9.46 8.54C9.73 8.26 9.81 7.87 9.7 7.52C9.33 6.41 9.14 5.22 9.14 3.99C9.14 3.45 8.69 3 8.15 3H4.69C4.15 3 3.5 3.24 3.5 3.99C3.5 13.28 11.23 21 20.51 21C21.22 21 21.5 20.37 21.5 19.82V16.37C21.5 15.83 21.05 15.38 20.51 15.38Z",
                              fill: "#D98240"
                            })
                          ], -1),
                          _createElementVNode("span", { class: "cta-text" }, " Bellen ", -1)
                        ]))], 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (
							_ctx.order.installation_information &&
							_ctx.order.installation_information.length > 0
						)
                  ? (_openBlock(), _createBlock(_component_base_panel, { key: 0 }, {
                      content: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.installationTitle), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.order.installation_information[0].key), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.formatInformationValue(
											_ctx.order.installation_information[0]
												.value
										)), 1)
                        ]),
                        _createVNode(_Transition, {
                          mode: "out-in",
                          name: "accordion",
                          onEnter: _ctx.enter,
                          onLeave: _ctx.leave,
                          onBeforeEnter: _ctx.beforeEnter,
                          onBeforeLeave: _ctx.beforeLeave
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.installation_information.slice(
											1,
											_ctx.order.installation_information
												.length
										), (informationItem, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "column"
                                }, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(informationItem.key), 1),
                                    (
													informationItem.options
														.length === 0
												)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.formatInformationValue(
														informationItem.value
													)), 1))
                                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(informationItem.options, (option, index) => {
                                          return (_openBlock(), _createElementBlock("p", {
                                            key: `option-${index}`,
                                            class: "value"
                                          }, [
                                            (
														_ctx.booleanFormatter(
															option.value
														) ===
														_ctx.booleanFormatter(
															informationItem.value
														)
													)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(option.label), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                  ])
                                ]))
                              }), 128))
                            ], 512), [
                              [_vShow, _ctx.showInstallationInformation]
                            ])
                          ]),
                          _: 1
                        }, 8, ["onEnter", "onLeave", "onBeforeEnter", "onBeforeLeave"])
                      ]),
                      cta: _withCtx(() => [
                        (!_ctx.showInstallationInformation)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "cta",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleInstallationInformation && _ctx.toggleInstallationInformation(...args)))
                            }, [
                              _cache[27] || (_cache[27] = _createElementVNode("svg", {
                                class: "icon",
                                fill: "fill",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 14L8 10H16L12 14Z",
                                  fill: "fill"
                                })
                              ], -1)),
                              _createElementVNode("span", _hoisted_18, [
                                _cache[26] || (_cache[26] = _createTextVNode(" Toon alles ", -1)),
                                _createElementVNode("span", _hoisted_19, "(" + _toDisplayString(_ctx.sum) + ")", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.showInstallationInformation)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "cta",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleInstallationInformation && _ctx.toggleInstallationInformation(...args)))
                            }, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass([{
										'accordion-active':
											_ctx.showInstallationInformation,
									}, "icon"]),
                                fill: "fill",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [...(_cache[28] || (_cache[28] = [
                                _createElementVNode("path", {
                                  d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 14L8 10H16L12 14Z",
                                  fill: "fill"
                                }, null, -1)
                              ]))], 2)),
                              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "cta-text" }, " Toon minder ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (
							_ctx.order.service_information &&
							_ctx.order.service_information.length > 0
						)
                  ? (_openBlock(), _createBlock(_component_base_panel, { key: 1 }, {
                      content: _withCtx(() => [
                        _cache[30] || (_cache[30] = _createElementVNode("h3", null, "Service informatie", -1)),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.order.service_information[0].key), 1),
                          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.formatInformationValue(
											_ctx.order.service_information[0].value
										)), 1)
                        ]),
                        _createVNode(_Transition, {
                          mode: "out-in",
                          name: "accordion",
                          onEnter: _ctx.enter,
                          onLeave: _ctx.leave,
                          onBeforeEnter: _ctx.beforeEnter,
                          onBeforeLeave: _ctx.beforeLeave
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.service_information.slice(
											1,
											_ctx.order.service_information.length
										), (informationItem, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "column"
                                }, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(informationItem.key), 1),
                                    (
													informationItem.options
														.length === 0
												)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.formatInformationValue(
														informationItem.value
													)), 1))
                                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(informationItem.options, (option, index) => {
                                          return (_openBlock(), _createElementBlock("p", {
                                            key: `option-${index}`,
                                            class: "value"
                                          }, [
                                            (
														_ctx.booleanFormatter(
															option.value
														) ===
														_ctx.booleanFormatter(
															informationItem.value
														)
													)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(option.label), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                  ])
                                ]))
                              }), 128))
                            ], 512), [
                              [_vShow, _ctx.showServiceInformation]
                            ])
                          ]),
                          _: 1
                        }, 8, ["onEnter", "onLeave", "onBeforeEnter", "onBeforeLeave"])
                      ]),
                      cta: _withCtx(() => [
                        (!_ctx.showServiceInformation)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "cta",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleServiceInformation && _ctx.toggleServiceInformation(...args)))
                            }, [
                              _cache[32] || (_cache[32] = _createElementVNode("svg", {
                                class: "icon",
                                fill: "fill",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 14L8 10H16L12 14Z",
                                  fill: "fill"
                                })
                              ], -1)),
                              _createElementVNode("span", _hoisted_28, [
                                _cache[31] || (_cache[31] = _createTextVNode(" Toon alles ", -1)),
                                _createElementVNode("span", _hoisted_29, "(" + _toDisplayString(_ctx.serviceInformationSum) + ")", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.showServiceInformation)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "cta",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleServiceInformation && _ctx.toggleServiceInformation(...args)))
                            }, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass([{
										'accordion-active':
											_ctx.showServiceInformation,
									}, "icon"]),
                                fill: "fill",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [...(_cache[33] || (_cache[33] = [
                                _createElementVNode("path", {
                                  d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 14L8 10H16L12 14Z",
                                  fill: "fill"
                                }, null, -1)
                              ]))], 2)),
                              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "cta-text" }, " Toon minder ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.order.order_lines)
                  ? (_openBlock(), _createBlock(_component_base_panel, {
                      key: 2,
                      class: "products"
                    }, _createSlots({
                      content: _withCtx(() => [
                        _cache[36] || (_cache[36] = _createElementVNode("h3", null, "Producten", -1)),
                        (
									_ctx.sortedOrderLines(_ctx.order.order_lines, 0)
										.length > 0
								)
                          ? (_openBlock(), _createBlock(_TransitionGroup, {
                              key: 0,
                              class: "grid product-list first-product-list",
                              name: "list",
                              tag: "div"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedOrderLines(_ctx.order.order_lines, 0), (orderLine, index) => {
                                  return (_openBlock(), _createBlock(_component_product_list_item, {
                                    key: orderLine.product.id,
                                    index: index,
                                    "is-finished": 
										_ctx.order.is_finished ||
										_ctx.authenticatedUserIsPlanner
									,
                                    "order-line": orderLine
                                  }, null, 8, ["index", "is-finished", "order-line"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (
									_ctx.sortedOrderLines(_ctx.order.order_lines, 1)
										.length > 0
								)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "added-by-mechanic" }, " Toegevoegd door monteur ", -1)),
                              _createVNode(_TransitionGroup, {
                                class: "grid product-list",
                                name: "list",
                                tag: "div"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedOrderLines(
											_ctx.order.order_lines,
											1
										), (orderLine, index) => {
                                    return (_openBlock(), _createBlock(_component_product_list_item, {
                                      key: orderLine.product.id,
                                      index: index,
                                      "is-finished": 
											_ctx.order.is_finished ||
											_ctx.authenticatedUserIsPlanner
										,
                                      "order-line": orderLine
                                    }, null, 8, ["index", "is-finished", "order-line"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, [
                      (
								!_ctx.order.is_finished &&
								(!_ctx.authenticatedUserIsPlanner ||
									_ctx.userId === _ctx.order.mechanic_id)
							)
                        ? {
                            name: "cta",
                            fn: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "cta",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openProductModal && _ctx.openProductModal(...args)))
                              }, [...(_cache[37] || (_cache[37] = [
                                _createElementVNode("svg", {
                                  class: "icon",
                                  fill: "fill",
                                  viewBox: "0 0 24 24",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z",
                                    fill: "fill"
                                  })
                                ], -1),
                                _createElementVNode("span", { class: "cta-text" }, " Extra product toevoegen ", -1)
                              ]))])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1024))
                  : _createCommentVNode("", true),
                (_ctx.totalPrice)
                  ? (_openBlock(), _createBlock(_component_base_panel, { key: 3 }, {
                      content: _withCtx(() => [
                        _cache[38] || (_cache[38] = _createElementVNode("h3", null, "Totaal prijs", -1)),
                        _createElementVNode("p", null, _toDisplayString(_ctx.totalPrice), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.totalPrice)
                  ? (_openBlock(), _createBlock(_component_base_panel, { key: 4 }, {
                      content: _withCtx(() => [
                        _cache[41] || (_cache[41] = _createElementVNode("h3", null, "Huidige situatie", -1)),
                        _createElementVNode("div", _hoisted_30, [
                          (_ctx.canAddImages)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                "aria-label": "Foto toevoegen",
                                class: "add-new-image",
                                type: "button",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openCamera && _ctx.openCamera(...args)))
                              }, [...(_cache[39] || (_cache[39] = [
                                _createElementVNode("svg", {
                                  class: "icon",
                                  fill: "fill",
                                  viewBox: "0 0 32 32",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M25.3333 9.33342V13.3201C25.3333 13.3201 22.68 13.3334 22.6667 13.3201V9.33342H18.6667C18.6667 9.33342 18.68 6.68008 18.6667 6.66675H22.6667V2.66675H25.3333V6.66675H29.3333V9.33342H25.3333ZM21.3333 14.6667V10.6667H17.3333V6.66675H6.66667C5.2 6.66675 4 7.86675 4 9.33342V25.3334C4 26.8001 5.2 28.0001 6.66667 28.0001H22.6667C24.1333 28.0001 25.3333 26.8001 25.3333 25.3334V14.6667H21.3333ZM6.66667 25.3334L10.6667 20.0001L13.3333 24.0001L17.3333 18.6667L22.6667 25.3334H6.66667Z",
                                    fill: "fill"
                                  })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createVNode(_TransitionGroup, { name: "image-anim" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copyOfImages, (image, imageIndex) => {
                                return (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                  key: image.url ? image.url : image.src,
                                  slot: "start",
                                  alt: "situation-image",
                                  class: "image"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: "overlay",
                                      onClick: ($event: any) => (
												_ctx.openImageModal(
													image,
													imageIndex
												)
											)
                                    }, [
                                      (image.uploadedAt)
                                        ? (_openBlock(), _createElementBlock("h6", _hoisted_32, _toDisplayString(image.uploadedAt.toLowerCase()), 1))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_31),
                                    (image.isNewImage)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                          _createElementVNode("div", {
                                            class: "remove-image",
                                            onClick: ($event: any) => (_ctx.removeImage(imageIndex))
                                          }, [...(_cache[40] || (_cache[40] = [
                                            _createElementVNode("svg", {
                                              class: "icon",
                                              fill: "none",
                                              viewBox: "0 0 8 8",
                                              xmlns: "http://www.w3.org/2000/svg"
                                            }, [
                                              _createElementVNode("path", {
                                                d: "M7.75 1.00536L6.99464 0.25L4 3.24464L1.00536 0.25L0.25 1.00536L3.24464 4L0.25 6.99464L1.00536 7.75L4 4.75536L6.99464 7.75L7.75 6.99464L4.75536 4L7.75 1.00536Z",
                                                fill: "white"
                                              })
                                            ], -1)
                                          ]))], 8, _hoisted_34)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_Transition, {
                                      mode: "out-in",
                                      name: "fade"
                                    }, {
                                      default: _withCtx(() => [
                                        (
													!image.loaded ||
													image.isUploading
												)
                                          ? (_openBlock(), _createBlock(_component_image_loader_overlay, { key: 0 }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_img, {
                                      src: 
												image.url
													? image.url
													: image.src
											,
                                      onIonImgDidLoad: ($event: any) => (
												_ctx.setImageLoaded(image)
											),
                                      onIonImgWillLoad: ($event: any) => (
												_ctx.setSelectedImage(image)
											)
                                    }, null, 8, ["src", "onIonImgDidLoad", "onIonImgWillLoad"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_in_app_camera_modal, {
                  ref: "in-app-camera",
                  onCaptured: _ctx.onPhotoCaptured
                }, null, 8, ["onCaptured"]),
                _createVNode(_component_sheet_modal, {
                  ref: `edit-email-modal`,
                  title: 'E-mailadres wijzigen'
                }, {
                  body: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_ion_input, {
                        modelValue: _ctx.updatedEmail,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.updatedEmail) = $event)),
                        class: "select-value",
                        inputmode: "email",
                        type: "email"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ion_button, {
                        class: "btn full-width ion-activatable ripple-parent",
                        color: "primary",
                        expand: "block",
                        shape: "round",
                        onClick: _ctx.updateEmailAddress
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.isUpdating)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Wijziging opslaan"))
                            : _createCommentVNode("", true),
                          (_ctx.isUpdating)
                            ? (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_ripple_effect)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_modal, {
                  ref: `show-image-modal`,
                  title: _ctx.selectedImage.uploadedAt
                }, {
                  body: _withCtx(() => [
                    _createVNode(_component_ion_slides, {
                      options: _ctx.imageSlideOptions,
                      pager: true,
                      class: "image-card-slider",
                      mode: "ios",
                      onIonSlideDidChange: _ctx.onImageSlideChanged
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copyOfImages, (image) => {
                          return (_openBlock(), _createBlock(_component_ion_slide, {
                            key: image.url ? image.url : image.src,
                            class: "card-slide"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_Transition, {
                                  mode: "out-in",
                                  name: "fade"
                                }, {
                                  default: _withCtx(() => [
                                    (!image.loaded)
                                      ? (_openBlock(), _createBlock(_component_image_loader_overlay, { key: 0 }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("img", {
                                  src: 
												image.url
													? image.url
													: image.src
											,
                                  alt: "situation-image",
                                  class: "image",
                                  onError: ($event: any) => (_ctx.setImageLoaded(image)),
                                  onLoad: ($event: any) => (_ctx.setImageLoaded(image))
                                }, null, 40, _hoisted_38)
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["options", "onIonSlideDidChange"])
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_card_modal, {
                  ref: 'add-product-modal',
                  title: 'Producten'
                }, {
                  "header-content": _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addableProductGroups, (item, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: index,
                          class: _normalizeClass([{
										'is-selected':
											_ctx.isGroupInSelectedAddableProductGroup(
												item.id
											),
									}, "category-item"]),
                          onClick: ($event: any) => (_ctx.setSelectedProductGroup(item))
                        }, _toDisplayString(_ctx.uppercaseFirstLetter(item.description)), 11, _hoisted_40))
                      }), 128))
                    ])
                  ]),
                  body: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_ion_searchbar, {
                        modelValue: _ctx.searchbarInput,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchbarInput) = $event)),
                        "search-icon": _ctx.SearchIcon,
                        class: "search-bar",
                        debounce: "350",
                        inputmode: "search",
                        mode: "ios",
                        placeholder: "Zoeken..",
                        onIonChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isFiltering = false)),
                        onIonInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isFiltering = true))
                      }, null, 8, ["modelValue", "search-icon"]),
                      _createVNode(_component_ion_list, {
                        class: _normalizeClass([{ 'is-filtering': _ctx.isFiltering }, "product-list"])
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isFiltering)
                            ? (_openBlock(), _createBlock(_component_base_loader, {
                                key: 0,
                                type: 'medium'
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.addableProducts.length === 0)
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_42, " Geen producten in de lijst. "))
                            : _createCommentVNode("", true),
                          _createVNode(_TransitionGroup, {
                            mode: "out-in",
                            name: "list-complete"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addableProducts, (product, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `addable-product-${index}`,
                                  slot: "center",
                                  class: "product-item ion-activatable ripple-parent",
                                  onClick: ($event: any) => (
												_ctx.toggleProductSelection(
													product.sku
												)
											)
                                }, [
                                  _createElementVNode("img", {
                                    alt: product.sku,
                                    src: product.image,
                                    class: "product-image"
                                  }, null, 8, _hoisted_44),
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(product.sku), 1),
                                    _createElementVNode("span", _hoisted_47, _toDisplayString(product.name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.formatPrice(product.price)), 1),
                                    _createVNode(_Transition, {
                                      mode: "out-in",
                                      name: "scale-pop"
                                    }, {
                                      default: _withCtx(() => [
                                        (
															product.isSelected
														)
                                          ? (_openBlock(), _createElementBlock("svg", _hoisted_50, [...(_cache[42] || (_cache[42] = [
                                              _createElementVNode("path", {
                                                d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
                                                fill: "fill"
                                              }, null, -1)
                                            ]))]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createVNode(_component_ion_ripple_effect)
                                ], 8, _hoisted_43))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_ion_button, {
                        disabled: 
										_ctx.selectedAddableProducts.length < 1
									,
                        class: "btn primary add-products-button",
                        color: "primary",
                        shape: "round",
                        onClick: _ctx.addSelectedProductsToOrder
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.isUpdating)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.selectedAddableProducts.length > 1
											? _ctx.selectedAddableProducts.length +
												" producten toevoegen"
											: "product toevoegen"), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isUpdating)
                            ? (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_sheet_modal, {
                  ref: `open-history-modal`,
                  title: 'Geschiedenis'
                }, {
                  body: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_ion_list, { class: "history-list" }, {
                        default: _withCtx(() => [
                          _createVNode(_TransitionGroup, {
                            mode: "out-in",
                            name: "list-complete"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.appointment_history, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `history-item-${index}`,
                                  class: "history-item ion-activatable ripple-parent",
                                  onClick: ($event: any) => (_ctx.moveToOrderDetail(item))
                                }, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("span", _hoisted_55, _toDisplayString(item.appointment_type), 1),
                                    _createElementVNode("span", _hoisted_56, _toDisplayString(new Date(
														item.date
													).toLocaleDateString(
														"nl-NL",
														_ctx.dateOptions
													)), 1)
                                  ]),
                                  (item.note)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [...(_cache[43] || (_cache[43] = [
                                        _createElementVNode("svg", {
                                          fill: "none",
                                          height: "24",
                                          viewBox: "0 0 25 24",
                                          width: "25",
                                          xmlns: "http://www.w3.org/2000/svg"
                                        }, [
                                          _createElementVNode("path", {
                                            d: "M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z",
                                            fill: "#D98240"
                                          }),
                                          _createElementVNode("path", {
                                            d: "M17 7.5H9C8.45 7.5 8 7.95 8 8.5V17.5L10 15.5H17C17.55 15.5 18 15.05 18 14.5V8.5C18 7.95 17.55 7.5 17 7.5Z",
                                            fill: "white"
                                          })
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_ripple_effect)
                                ], 8, _hoisted_53))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_panel, null, {
                  content: _withCtx(() => [
                    _cache[44] || (_cache[44] = _createElementVNode("h3", null, "Defecte onderdelen", -1)),
                    _cache[45] || (_cache[45] = _createElementVNode("p", { class: "defective-parts-question" }, " Zijn er defecte onderdelen te melden? ", -1)),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("button", {
                        class: _normalizeClass({ active: !_ctx.hasDefectiveParts }),
                        disabled: !_ctx.canEditDefectiveParts,
                        type: "button",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.hasDefectiveParts = false))
                      }, " Nee ", 10, _hoisted_59),
                      _createElementVNode("button", {
                        class: _normalizeClass({ active: _ctx.hasDefectiveParts }),
                        disabled: !_ctx.canEditDefectiveParts,
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.hasDefectiveParts = true))
                      }, " Ja ", 10, _hoisted_60)
                    ]),
                    _withDirectives(_createVNode(_component_defective_parts_section, {
                      ref: "defectivePartsSection",
                      active: _ctx.hasDefectiveParts,
                      "appointment-id": _ctx.order.id,
                      editable: _ctx.canEditDefectiveParts,
                      products: _ctx.allAddableProducts,
                      onLoaded: _ctx.onDefectivePartsLoaded
                    }, null, 8, ["active", "appointment-id", "editable", "products", "onLoaded"]), [
                      [_vShow, _ctx.hasDefectiveParts]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_panel, null, {
                  content: _withCtx(() => [
                    _cache[48] || (_cache[48] = _createElementVNode("h3", null, "Overig", -1)),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _cache[46] || (_cache[46] = _createElementVNode("p", { class: "label" }, "Dealeigenaar", -1)),
                        _createElementVNode("p", null, _toDisplayString(_ctx.order.ticket_owner
												? _ctx.order.ticket_owner
												: "-"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _cache[47] || (_cache[47] = _createElementVNode("p", null, "Opmerking", -1)),
                        (
											!_ctx.order.is_finished &&
											(!_ctx.authenticatedUserIsPlanner ||
												_ctx.userId === _ctx.order.mechanic_id)
										)
                          ? (_openBlock(), _createBlock(_component_ion_textarea, {
                              key: 0,
                              "auto-grow": true,
                              value: _ctx.order.mechanic_comment,
                              class: "textarea",
                              inputmode: "text",
                              placeholder: "Voeg eventueel een opmerking toe",
                              onIonInput: _cache[15] || (_cache[15] = ($event: any) => (
											_ctx.updateMechanicComment(
												$event.target.value
											)
										))
                            }, null, 8, ["value"]))
                          : (
											_ctx.order.is_finished ||
											_ctx.authenticatedUserIsPlanner
										)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_ctx.order.mechanic_comment
												? _ctx.order.mechanic_comment
												: "Geen opmerking."), 1))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, {
                  name: "scale-save",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (_ctx.orderLineHasChanged)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          disabled: _ctx.isUpdating,
                          class: "btn primary full-width ion-activatable ripple-parent save-btn",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateOrder()))
                        }, [
                          _createVNode(_Transition, { name: "fade" }, {
                            default: _withCtx(() => [
                              (!_ctx.isUpdating)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, "Wijziging opslaan"))
                                : (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_ripple_effect)
                        ], 8, _hoisted_65))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (
							!_ctx.order.is_finished &&
							(!_ctx.authenticatedUserIsPlanner ||
								_ctx.userId === _ctx.order.mechanic_id)
						)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      disabled: _ctx.isUpdating,
                      class: "btn full-width primary ion-activatable ripple-parent",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toNextStep && _ctx.toNextStep(...args)))
                    }, [
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          (!_ctx.isUpdating)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Volgende stap"))
                            : (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_ripple_effect)
                    ], 8, _hoisted_67))
                  : _createCommentVNode("", true),
                (_ctx.order.is_finished)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 6,
                      disabled: _ctx.isUpdating,
                      class: "btn primary full-width ion-activatable ripple-parent",
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toNextStepFinished && _ctx.toNextStepFinished(...args)))
                    }, [
                      _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                          (!_ctx.isUpdating)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_70, "Volgende stap"))
                            : (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_ripple_effect)
                    ], 8, _hoisted_69))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}